// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 132) return "static/chunks/132-3a3a75f2ad24eecb.js";
	if (chunkId === 819) return "static/chunks/819-3b962b7a7d0509ce.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"782":"91ec02ef9ba9dadb","830":"a99adfa0a0128559","906":"c0c9a2473165f510"}[chunkId] + ".js";
};